import React, { FC, useState } from "react";
import classNames from "classnames";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Accordion } from "@app/components/common/accordion/Accordion";
import { Link } from "@app/components/common/link/Link";
import { INavigationMenuItem } from "@app/models/storyblok/datasource";
import { MenuGroup } from "./components/menu-group/MenuGroup";

type Props = {
  data: INavigationMenuItem[];
  onClose: () => void;
};

export const Menu: FC<Props> = ({ data, onClose }) => {
  const { language, defaultLanguage } = useI18next();
  const [activeGroup, setActiveGroup] = useState("");

  const onParentEntryClick = (id: string) =>
    setActiveGroup(id === activeGroup ? "" : id);

  return (
    <div
      className={classNames(
        "scrollbar-hidden text-base-content overflow-x-hidden overflow-y-auto px-5",
      )}
    >
      {data.map((navGroup) =>
        navGroup.groups?.length ? (
          <Accordion
            key={navGroup.id}
            isOpen={navGroup.id === activeGroup}
            onToggleIsOpen={() => onParentEntryClick(navGroup.id)}
            header={
              <span>
                {navGroup.name[language] ?? navGroup.name[defaultLanguage]}
              </span>
            }
            body={<MenuGroup data={navGroup.groups} {...{ onClose }} />}
            headerStyles="text-medium"
          />
        ) : (
          <div key={navGroup.id} className={classNames("text-medium py-3")}>
            <Link
              to={navGroup.ref}
              className="hover:text-base-content/50 no-underline duration-300"
              onClick={onClose}
            >
              {navGroup.name[language] ?? navGroup.name[defaultLanguage]}
            </Link>
          </div>
        ),
      )}
    </div>
  );
};
